import { Grid as BaseGrid, type GridProps } from '@mui/material';

export default function Grid(props: GridProps) {
  return <BaseGrid {...props} />;
}
